<template>
  <div>
    <div class="headtop">
		<div class="headtoplf">
			<img class="logoimg" src="../assets/loginicon.png" alt="logo"/>
			<span class="logotit">外呼系统</span>
		</div>
    	<div class="headtoprt">
    		<img v-if="avatarUrl" class="logoimg" :src="avatarUrl" alt="logo"/>
			<img v-else class="logoimg" src="../assets/touxiangdifult.png" alt="logo"/>
			<span class="username">{{nickname}}</span>
			<span @click="getisvercall" class="sethzujiaohm">设置主叫号码</span>
			<span @click="quitout" class="tuichu">退出</span>
    	</div>
    </div>
	
	<!-- 设置主叫号码弹窗 -->
	<el-dialog title="设置主叫号码" :visible.sync="setmaincallVisible">
	 <div class="bodadh">
	 	<el-input
	 	    placeholder="请输入主叫手机号"
	 	    prefix-icon="el-icon-phone"
	 	    v-model="callNumber">
	 	</el-input>
		<el-button @click="takePhone" circle class="bohaobtn">提交</el-button> 
	 </div>
	</el-dialog>
	
  </div>
</template>

<script>
	import * as IndexAPI from '@/services/index'
export default {
  name: 'headerTop',
  props: {
    msg: String
  },
  data(){
  	return{
		setmaincallVisible:false,
  		avatarUrl:'',
		callNumber:'',
		nickname:'',
		userinfor:{}
  	}
  },
  created() {
	
	if(localStorage.getItem('userInfor') ){
		let UserInfor=localStorage.getItem('userInfor')
		let userInfor=JSON.parse(UserInfor)
		
		this.avatarUrl=userInfor.avatarUrl?userInfor.avatarUrl:''
		
		this.nickname=userInfor.nick
		
		this.userinfor = JSON.parse(UserInfor)
	}
	
  },
  methods: {
	  //显示设置主叫弹窗
	  setmaincall(){
		  this.setmaincallVisible=true
	  },
	  //提交设置主叫
	  takePhone(){
		  if(this.callNumber==''){
			  this.$message({
				   message: '手机号不能为空',
				   type: 'warning'
			  })
			  return false
		  }
		  let data={
		  	openId:this.userinfor.openid,
			caller:this.callNumber
		  }
		  IndexAPI.setUserCaller(data).then((res)=>{	
		  	if(res.data.success== true){
		  		this.setmaincallVisible=false
				this.callNumber=''
				this.$message({
				   message: res.data.message,
				   type: 'success'
				})	
		  	}else{
				 this.$message.error(res.data.message)
			}
					
						
		  })	
		  
		  
	  },
	  //是否设置主叫
	  getisvercall(){
	  		  let data={
	  		  	openId:this.userinfor.openid
	  		  }
	  		  IndexAPI.isvercall(data).then((res)=>{	
	  		  	if(res.data.success== true){
					if(res.data.entity!=''){
						this.callNumber = res.data.entity
						//显示设置主叫弹窗
						this.setmaincall()
					}
					
	  		  	}else{
	  				 this.$message.error(res.data.message)
	  			}
			
	  		  })	
 
	  },
	  //点击退出
		quitout(){
			localStorage.clear()
			
			if(window.location.hash != '#/login'){
				location.href='/#/login'
			}
		}
  }
  
}
</script>

<style scoped lang="scss">
.headtop{
	width: 100%;
	box-sizing: border-box;
	padding: 20px 60px;
	background-color: #fff;
	box-shadow: 0 2px 20px #f0f0f0;
	display: flex;
	align-items: center;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 2;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.logoimg{
	width: 40px;
	margin-right: 15px;
}
.logotit{
	font-size: 24px;
	font-weight: bold;
	font-style: oblique;
	letter-spacing: 5px;
}
.headtoplf{
	display: flex;
	align-items: center;
}
.headtoprt{
	display: flex;
	align-items: center;
}
.tuichu{
	text-decoration: underline;
	cursor: pointer;
	margin-left: 15px;
	padding-left: 15px;
	border-left: 1px solid #ccc;
	
}
.sethzujiaohm{
	text-decoration: underline;
	cursor: pointer;
	margin-left: 15px;
	padding-left: 15px;
	border-left: 1px solid #ccc;
}
.tuichu:hover{
	color: #8c7bfd;
}
.sethzujiaohm:hover{
	color: #8c7bfd;
}
.logoimg{
	width: 40px;
	height: 40px;
	border-radius: 50%;
}

.bodadh{
		display: flex;
		align-items: center;
		width: 60%;
		margin: 0 auto;
		margin-bottom: 30px;
	}
	.bohaobtn{
		margin-left: 20px;
		line-height: 25px;
		background-color:#8c7bfd;
		color: #fff;
	}
	.bohaobtn:hover{
		background-color:#9d94fd;
		color: #fff;
	}
	
	
</style>













